require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./research-watch-learn-vote-five-years-of-research-in-3-minutes-dr-jean-jacques-lebruns-team-discovers-promising-treatment-for-triple-negative-breast-cancer.json") })
        }
      }, "path---research-watch-learn-vote-five-years-of-research-in-3-minutes-dr-jean-jacques-lebruns-team-discovers-promising-treatment-for-triple-negative-breast-cancer");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---research-watch-learn-vote-five-years-of-research-in-3-minutes-dr-jean-jacques-lebruns-team-discovers-promising-treatment-for-triple-negative-breast-cancer!./.cache/json/research-watch-learn-vote-five-years-of-research-in-3-minutes-dr-jean-jacques-lebruns-team-discovers-promising-treatment-for-triple-negative-breast-cancer.json
// module id = 493
// module chunks = 231608221292675